module.exports = __webpack_public_path__ + "img/calendar3-range-fill.132ccc1b.svg";